export const captionDefaultAttributes = {
  styleDefaults: {
    paddingTop: '16px',
    paddingBottom: '16px',
  },
  textStyle: {
    textAlignment: 'CENTER',
    lineHeight: 1.5,
  },
};
